export const checkTokenExpiration = (timestamp) => {
  const expiration = new Date(timestamp).getTime()
  const now = new Date().getTime()
  return !!((expiration - now) <= 0)
}
